import * as React from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import './FloatingHeader.scss';
import Wrapper from '../Wrapper';
import FlexContainer from '../Layout/FlexContainer';
import logo from './logo.svg';
import lock from 'src/images/lock.svg';
import { IMenuItem, IHeaderProps } from '../GlobalHeader/types';
import { Link } from 'react-router-dom';

interface IState {
  expanded: boolean;
  expandedItems: IMenuItem[];
}

class FloatingHeader extends React.Component<IHeaderProps, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      expanded: false,
      expandedItems: []
    }

    this.renderMenuItem = this.renderMenuItem.bind(this);
    this.handleBurgerClick = this.handleBurgerClick.bind(this);
  }

  public handleBurgerClick() {
    this.setState({ expanded: !this.state.expanded });
  }

  public toggleMenuItem(item: IMenuItem, event: React.MouseEvent) {
    event.stopPropagation();
    event.preventDefault();

    const isExpanded = this.state.expandedItems.indexOf(item) >= 0;

    if (isExpanded) {
      this.setState({
        expandedItems: this.state.expandedItems
          .filter(expandedItem => item !== expandedItem)
      })
    } else {
      this.setState({
        expandedItems: [...this.state.expandedItems, item]
      })
    }
  }

  public handleItemClick(item: IMenuItem, event: React.MouseEvent) {
    event.stopPropagation();
  }

  public renderMenuItem(item: IMenuItem) {
    const hasChildren = item.children.length > 0;
    const isChildrenExpanded = hasChildren && this.state.expandedItems.indexOf(item) !== -1;
    const classes = classNames({
      'has-children': hasChildren,
      'is-active': item.active,
      'is-open': isChildrenExpanded,
    });
    
    return (
      <li 
        key={item.path} 
        className={classes} 
        onClick={hasChildren
          ? this.toggleMenuItem.bind(this, item)
          : this.handleItemClick.bind(this, item)}
      >
        <Link to={item.path}>
          {item.label}
          
          {hasChildren ? <div className="floating-menu-arrow" /> : null}
        </Link>
        
        <ul className="sub-menu">
          {hasChildren ? item.children.map(this.renderMenuItem) : null}
        </ul>
      </li>
    )
  }

  public render() {
    const { userName, unionName } = this.props;

    const classes = classNames('floating-menu', {
      'is-expanded': this.state.expanded
    });

    return (
      <div className={classes}>
        <div className="floating-menu-panel has-background-blue has-text-white">
          <Wrapper>
            <FlexContainer alignItems="center">
              {this.state.expanded && (
                <strong>
                  {`Velkommen ${userName}, ${unionName}`}
                  <img src={lock} width="8" className="ml2" />
                </strong>
              )}

              <img src={logo} className="logo" />
              <div
                className={classNames(
                  'floating-menu-burger',
                  this.state.expanded && 'is-active'
                )}
                onClick={this.handleBurgerClick}
              >
                <span />
                <span />
                <span />
              </div>
            </FlexContainer>
          </Wrapper>
        </div>
        <CSSTransition
          in={this.state.expanded}
          timeout={300}
          classNames="floating-menu-fade"
          unmountOnExit={true}
        >
          {state => (
            <div className="floating-menu-content">
              <Wrapper>
                <ul className="floating-menu-items">
                  {this.props.menuItems.map(this.renderMenuItem)}
                </ul>
              </Wrapper>
            </div>
          )}
        </CSSTransition>
      </div>
    );
  }
}

export default FloatingHeader;



// WEBPACK FOOTER //
// ./src/components/FloatingHeader/index.tsx